import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import MeetingForm from 'components/installation/meetingForm/meetingForm';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import ErrModalPop from 'components/sales/modal/errorModal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Regex from 'services/utils/regex/Regex';
import parse from 'html-react-parser';

const ScheduleMeeting = ({
  getMeetingById,
  meetingById,
  documentUploadUrl,
  documentUrlData,
  pocList,
  getPocList,
  createMeeting,
  match,
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');

  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  const handleSubmit = () => {
    // console.log(meetingData); return false;
    const { meetingDetails } = meetingData;
    if (
      meetingDetails.poc_list !== '' &&
      meetingDetails.meeting_date !== '' &&
      meetingDetails.subject !== '' &&
      meetingDetails.summary !== '' &&
      Regex.email.test(meetingDetails.other_email)
    ) {
      setIsFiled(false);
      (async () => {
        setIsLoading(true);
        const res = await createMeeting(meetingDetails);
        setIsLoading(false);
        if (res) {
          setIsModal(true);
          
        }
      })();
    }else{
      var errMsg = '';
      if(meetingDetails.poc_list === ''){
        errMsg = errMsg+'Name Is Required!<br/>';  
      }
      if(meetingDetails.meeting_date === ''){
        errMsg = errMsg+'Meetind Date Is Required! <br/>';  
      }
      if(meetingDetails.subject === ''){
        errMsg = errMsg+'Subject Is Required! <br/>';  
      }
      if(meetingDetails.summary === ''){
        errMsg = errMsg+'Summary Is Required! <br/>';  
      }
      setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsFiled(true);
       setIsModal(false);
       return false;
    }
    
  };

  useEffect(() => {
    (async () => {
      if (match?.params?.meetingId) {
        setIsLoading(true);
        await getMeetingById(match?.params?.meetingId);
        setIsLoading(false);
      }
    })();
  }, [getMeetingById, match?.params?.meetingId]);

  useEffect(() => {
    setSiteId(match.params.id);
    if (match.params.id) {
      (async () => {
        setIsLoading(true);
        await getPocList(match.params.id);
        setIsLoading(false);
      })();
    }
  }, [getPocList, match.params.id]);
  const handleModalHide = () => setIsModal(false);
  const handleModalHide1 = () => setIsErrorModal(false);


  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.scheduleMeeting}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  return (
    <Layout
      title={
        match?.params?.meetingId
          ? localization.rescheduleMeeting
          : localization.scheduleMeeting
      }
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={
        match?.params?.meetingId
          ? `${baseUrl}/meeting-details-scheduled/${match?.params?.meetingId}`
          : `${baseUrl}/meeting-history/${siteId}`
      }
    >
      <MeetingForm
        pocList={pocList}
        getMeetingById={getMeetingById}
        meetingById={match?.params?.meetingId ? meetingById : null}
        handleValue={handleForm}
        siteId={siteId}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingSuccess}</h5>
          <Link
            to={`${baseUrl}/meeting-history/${siteId}`}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};

ScheduleMeeting.propTypes = {};

export default ScheduleMeeting;
